/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */

class GmaoFormButtonsController {
    /** @ngInject */
    constructor($log, $window) {
        this.$log = $log;
        this.$window = $window;
        this.$log.debug('Controller \'GmaoFormButtons\' loaded');
    }

    onCancel() {
        this.$window.history.back();
    }
}

export const gmaoFormButtonsComponent = {
    template: require('./gmao-form-buttons.html'),
    controller: GmaoFormButtonsController,
    bindings: {
        disabled: '<',
        onSave: '&',
        onReset: '&?'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoFormButtons.js